module.exports = __webpack_public_path__ + "img/lock-closed-outline.10458b42.svg";